import { render, staticRenderFns } from "./ShaimAresButton.vue?vue&type=template&id=a867c016&"
import script from "./ShaimAresButton.vue?vue&type=script&lang=js&"
export * from "./ShaimAresButton.vue?vue&type=script&lang=js&"
import style0 from "./ShaimAresButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports